import {
  getResponsiveProps
} from "./chunk-7ROE6ADK.mjs";
import {
  getSpacingVariable
} from "./chunk-NE6W2PCD.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/layout/grid/grid.tsx
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { Slot } from "@radix-ui/react-slot";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var GridItem = forwardRef(
  (_a, ref) => {
    var _b = _a, { children, asChild, className, span, center, style: _style } = _b, rest = __objRest(_b, ["children", "asChild", "className", "span", "center", "style"]);
    const Component = asChild ? Slot : "div";
    const style = __spreadValues(__spreadValues(__spreadValues({}, _style), getResponsiveProps("--hds-grid-item-span", span)), getResponsiveProps("--hds-grid-item-center", center, (value) => value ? "1" : "0"));
    return /* @__PURE__ */ jsx(
      Component,
      __spreadProps(__spreadValues({
        style,
        className: clsx("hds-grid__item", className),
        ref
      }, rest), {
        children
      })
    );
  }
);
GridItem.displayName = "Grid.Item";
var Grid = forwardRef(
  (_a, ref) => {
    var _b = _a, { children, asChild, className, span, center, style: _style, gap, gapX, gapY } = _b, rest = __objRest(_b, ["children", "asChild", "className", "span", "center", "style", "gap", "gapX", "gapY"]);
    const Component = asChild ? Slot : "div";
    const style = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, _style), getResponsiveProps("--hds-grid-gap", gap, getSpacingVariable)), getResponsiveProps("--hds-grid-gap-x", gapX, getSpacingVariable)), getResponsiveProps("--hds-grid-gap-y", gapY, getSpacingVariable)), getResponsiveProps("--hds-grid-span", span)), getResponsiveProps("--hds-grid-center", center, (value) => value ? "1" : "0"));
    return /* @__PURE__ */ jsx(
      Component,
      __spreadProps(__spreadValues({
        style,
        className: clsx("hds-grid", className),
        ref
      }, rest), {
        children
      })
    );
  }
);
Grid.displayName = "Grid";
Grid.Item = GridItem;

export {
  GridItem,
  Grid
};
//# sourceMappingURL=chunk-TC5PD4TA.mjs.map